import React from 'react';
import { Box, TextButton, Text } from '@wix/design-system';
import { StatusesModule } from '../StatusesModule';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { ArrowRight } from '@wix/wix-ui-icons-common/lazy';
import { useIsHarmonyTheme } from '@wix/core-domain-search';
export const DomainIsTaken = _ref => {
  let {
    domainName,
    action,
    status
  } = _ref;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  const isHarmonyTheme = useIsHarmonyTheme();
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    padding: "SP6 SP3 SP5 SP3",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
    transform: "translateY(-4px)",
    backgroundColor: isHarmonyTheme ? 'var(--wds-color-fill-standard-tertiary-readonly)' : '#F7F5F3',
    dataHook: StatusesModule.internals.dataHooks.domainIsTaken,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.domain_taken",
    values: {
      domainName
    },
    components: [/*#__PURE__*/React.createElement(Text, {
      size: "small",
      weight: "bold"
    }), /*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      suffixIcon: /*#__PURE__*/React.createElement(ArrowRight, null),
      onClick: () => {
        action == null || action();
        DomainSearchSuiteModule.internals.bi.onDomainIsTakenAction == null || DomainSearchSuiteModule.internals.bi.onDomainIsTakenAction({
          domainName: domainName ?? 'unknown',
          status
        });
      },
      dataHook: StatusesModule.internals.dataHooks.domainIsTakenAction
    })]
  })));
};
//# sourceMappingURL=DomainIsTaken.js.map